import React from "react";
import CalendarTable from "./components/CalendarTable";
import TrainerCalender from "./components/TrainerCalender";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h1 className="text-4xl font-bold text-center mb-8">Training Calendar 2026</h1>
      <CalendarTable />
      {/* <TrainerCalender /> */}
    </div>
  );
}

export default App;
